import TokenResource from "./TokenResource";

export default class BackofficeApplicationResource extends TokenResource {
	accountNr = "";
	dueDate = "";
	firstDueDate = "";
	fulfilled = false;
	hasPaymentInsurance = false;
	id = 0;
	installmentAmount = 0;
	interestRate = 0;
	kidNrFromLastInvoice = 0;
	loanAmount = 0;
	loanBalance = 0;
	nextDueDate = "";
	objectMake = "";
	objectModel = "";
	objectIcon = "";
	objectYear = "";
	regNumber = "";
	remainingCost = 0;
	remainingTerms = 0;
	restDeductionFree = 0;
	termFee = 0;
	termLength = 1;
	terms = [];
	toDebtCollection = false;
	debtCollectionCode = "";
	totalCost = 0;
	totalDeductionFree = 0;
	updatedInterestRateAfterChange = 0;
	isLeasingContract = false;

	pk() {
		return this.id?.toString() ?? "";
	}

	static urlRoot = "/api/backofficeapplications";
}
